import { render, staticRenderFns } from "./importarArchivo.vue?vue&type=template&id=1e72e1e8&scoped=true&"
import script from "./importarArchivo.vue?vue&type=script&lang=js&"
export * from "./importarArchivo.vue?vue&type=script&lang=js&"
import style0 from "./importarArchivo.vue?vue&type=style&index=0&id=1e72e1e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e72e1e8",
  null
  
)

export default component.exports